import { render } from "./ArticleIndex.vue?vue&type=template&id=cc011074"
import script from "./ArticleIndex.vue?vue&type=script&lang=js"
export * from "./ArticleIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__